interface Props {
  readonly size?: number;
  readonly className?: string;
  readonly title?: string;
}

export default function LockIcon(props: Props) {
  const { size = 18, ...rest } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M13 7.6234H4.9352c-1.6569 0-3 1.3432-3 3v3.3812c0 1.6568 1.3431 3 3 3H13c1.6569 0 3-1.3432 3-3v-3.3812c0-1.6568-1.3431-3-3-3Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.3816 12.8973v-1.1667a.586.586 0 1 1 1.172 0v1.1667a.586.586 0 1 1-1.172 0Z"
        fill="currentColor"
      />
      <path
        d="M4.555 7.8906V5.4171c0-2.437 1.9756-4.4125 4.4126-4.4125 2.437 0 4.4126 1.9756 4.4126 4.4125v2.4735"
        stroke="currentColor"
      />
    </svg>
  );
}
